import React from 'react';
import { observer } from "mobx-react";

import { countyRecentPM25Store } from '../store/apiStores'
import { getMonitoringV4Links } from '../lib/externalTools'

import './MonitoringV4Links.css'

export default observer(function MonitoringV4Links(props) {
    // getMonitoringV4Links handles undefined data
    let monitoringV4Urls = getMonitoringV4Links(countyRecentPM25Store.data);
    if (monitoringV4Urls.individual) {
        return (
            <div className="monitoring-v4-links">
                <h5>Monitoring V4 links: </h5>
                <ul>
                    <li>
                        <a href={monitoringV4Urls.all} target="_blank"
                            rel="noopener noreferrer">All</a>
                    </li>
                {monitoringV4Urls.individual.map((e) => (
                    <li key={e.monitorId}>
                        <a href={e.url} target="_blank"
                            rel="noopener noreferrer">{e.siteName}</a>&nbsp;
                        (<a href={e.dataReportUrl} target="_blank"
                            rel="noopener noreferrer">data report</a>)
                    </li>
                ))}
                </ul>
            </div>
        )
    } else {
        return null
    }
})
